// extracted by mini-css-extract-plugin
module.exports = {"card":"course-type-card-module--card--nAoNt","cardCover":"course-type-card-module--cardCover--38y8e","textbox":"course-type-card-module--textbox--PFhDf"};